// extracted by mini-css-extract-plugin
export var width100 = "F_w d_w";
export var design3Pos = "F_vh d_0";